import { Component, OnInit } from '@angular/core';
declare let $: any;
@Component({
  selector: 'app-leavemaster',
  templateUrl: './leavemaster.component.html',
  styleUrls: ['./leavemaster.component.scss']
})
export class LeavemasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  leaveMaster(): void
  {
    $('#leave_master').modal('show');
  }

}
